(function () {
  'use strict';

  function humanizeTagName(name) {
    if (!name || typeof name !== 'string') return name;
    var upper = name.toUpperCase();
    if (upper === 'PIH') return 'Post-acne dark marks';
    return name.replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }).trim();
  }

  function renderFaceScanAnalysis(data, options) {
    var opts = options || {};
    var categorizedProfile = opts.categorizedProfile || {};
    var isPlaceholderNoImage = !!opts.placeholderNoImage;
    if (!data || typeof data !== 'object') {
      data = {};
    }
    if (isPlaceholderNoImage) {
      data = { Tags: [], tags: [] };
    }

    function escapeHtmlAttr(s) {
      return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;');
    }

    var styleId = 'fsr-dynamic-overrides-v2';
    var styleEl = document.getElementById(styleId);
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = styleId;
      styleEl.innerHTML = `
        .products-skin-concerns-dropdown .fsr-gauge-scale {
            background: conic-gradient(from 220deg, rgba(34, 197, 94, 0.30) 0deg, rgba(245, 158, 11, 0.30) 140deg, rgba(239, 68, 68, 0.30) 280deg, transparent 280deg 360deg) !important;
        }
        .products-skin-concerns-dropdown .fsr-progress-arc {
            background: conic-gradient(from 220deg, #22c55e 0deg, #f59e0b 140deg, #ef4444 var(--fsr-progress-deg), transparent var(--fsr-progress-deg) 360deg) !important;
        }
        .products-skin-concerns-dropdown .fsr-face-circle {
            border-radius: 15px !important;
            inset: 21% !important;
            box-shadow: 0 4px 12px rgba(0,0,0,0.12) !important;
            overflow: hidden !important;
            background: #fff !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            z-index: 1 !important;
        }
        .products-skin-concerns-dropdown .fsr-face-preview-img {
            width: 100% !important;
            height: 100% !important;
            object-fit: contain !important;
            object-position: center !important;
            transform: scale(1.0) !important;
            transform-origin: center !important;
            transition: transform 0.3s ease-in-out !important;
            background: #ffffff !important;
        }
        .products-skin-concerns-dropdown .fsr-face-preview-img:hover {
            transform: scale(1.05) !important;
        }
      `;
      document.head.appendChild(styleEl);
    }

    function rawBase64ToDataUrl(raw) {
      if (!raw || typeof raw !== 'string') return '';
      var s = raw.trim();
      if (!s) return '';
      if (s.indexOf('data:') === 0) return s;
      var mime = 'image/png';
      if (s.indexOf('/9j/') === 0) mime = 'image/jpeg';
      else if (s.indexOf('UklG') === 0) mime = 'image/webp';
      return 'data:' + mime + ';base64,' + s;
    }

    function base64EntryToDataUrl(entry) {
      if (!entry || typeof entry !== 'object') return '';
      var raw = entry.value != null ? String(entry.value).trim() : (entry.Value != null ? String(entry.Value).trim() : '');
      return rawBase64ToDataUrl(raw);
    }

    function firstDataUrlForKeyNames(obj, names) {
      if (!obj || !names || !names.length) return '';
      var upper = {};
      Object.keys(obj).forEach(function (k) {
        upper[k.toUpperCase()] = obj[k];
      });
      for (var i = 0; i < names.length; i++) {
        var nm = names[i];
        var entry = obj[nm] != null ? obj[nm] : upper[String(nm).toUpperCase()];
        var url = base64EntryToDataUrl(entry);
        if (url) return url;
      }
      return '';
    }

    /** When API puts *_IMAGE_FAST only inside Tags[], not as top-level keys. */
    function dataUrlFromImageTag(tag) {
      var tvs = tag.TagValues || tag.tagValues || [];
      for (var i = 0; i < tvs.length; i++) {
        var v = tvs[i];
        if (!v) continue;
        var raw = v.Value != null ? String(v.Value).trim() : (v.value != null ? String(v.value).trim() : '');
        if (!raw) continue;
        var u = (v.Units || v.units || '').toString().trim().toLowerCase();
        var compact = raw.replace(/\s/g, '');
        var looksB64 = u === 'base64' || isLikelyBase64MetricValue(raw) ||
          (compact.length >= 40 && /^[A-Za-z0-9+/=]+$/.test(compact) &&
            (compact.indexOf('/9j/') === 0 || compact.indexOf('iVBOR') === 0 || compact.indexOf('UklG') === 0));
        if (looksB64) {
          var url = rawBase64ToDataUrl(raw);
          if (url) return url;
        }
      }
      return '';
    }

    function imageTagUrlMap(tags) {
      var map = {};
      if (!Array.isArray(tags)) return map;
      for (var i = 0; i < tags.length; i++) {
        var tn = normTagName(tags[i]);
        if (!isImageishTagName(tn)) continue;
        var u = dataUrlFromImageTag(tags[i]);
        if (u) map[tn] = u;
      }
      return map;
    }

    function firstDataUrlFlatOrTags(obj, orderedKeys, tags) {
      var flat = firstDataUrlForKeyNames(obj, orderedKeys);
      if (flat) return flat;
      var map = imageTagUrlMap(tags);
      for (var k = 0; k < orderedKeys.length; k++) {
        var key = String(orderedKeys[k]).toUpperCase();
        if (map[key]) return map[key];
      }
      for (k = 0; k < orderedKeys.length; k++) {
        key = String(orderedKeys[k]).toUpperCase();
        for (var tn in map) {
          if (!Object.prototype.hasOwnProperty.call(map, tn)) continue;
          if (tn === key || tn.indexOf(key) === 0 || key.indexOf(tn) === 0) return map[tn];
        }
      }
      return '';
    }

    function cleanFaceTagLabel(rawName) {
      var normalized = humanizeTagName(rawName || '');
      normalized = normalized.replace(/\bseverity\b/gi, '');
      normalized = normalized.replace(/\s{2,}/g, ' ').replace(/\s-\s/g, ' ').trim();
      return normalized || 'Tag';
    }

    function normTagName(tag) {
      return (tag.TagName || tag.tagName || '').toUpperCase().replace(/\s+/g, '_');
    }

    function isImageishTagName(nameUpper) {
      return nameUpper ? /_IMAGE/i.test(nameUpper) : false;
    }

    function isLikelyBase64MetricValue(str) {
      if (!str || typeof str !== 'string') return false;
      var s = str.trim();
      if (s.length < 80) return false;
      if (!/^[A-Za-z0-9+/=\s]+$/.test(s)) return false;
      return s.indexOf('/9j/') === 0 || s.indexOf('iVBOR') === 0 || s.indexOf('UklG') === 0;
    }

    function getTagDisplayParts(tag) {
      var status = tag.Status || tag.status;
      var tagValues = tag.TagValues || tag.tagValues || [];
      var displayStr = '';
      var rawStr = '';
      var units = '';

      if (Array.isArray(tagValues) && tagValues.length > 0) {
        var bestV = tagValues.find(function (v) {
          var vn = (v.ValueName || v.valueName || '').toLowerCase();
          return vn === 'combined' || vn === 'total' || vn === 'overall';
        });
        if (!bestV) {
          bestV = tagValues.find(function (v) {
            return v.Value != null && String(v.Value).trim() !== '';
          });
        }
        if (!bestV) bestV = tagValues[0];

        if (bestV) {
          var val = (bestV.Value != null) ? String(bestV.Value).trim() : '';
          var uLow = (bestV.Units || bestV.units || '').toString().trim().toLowerCase();
          if (uLow === 'base64' || isLikelyBase64MetricValue(val)) {
            val = '';
          }
          if (val !== '') {
            rawStr = val;
            units = (bestV.Units || bestV.units || '').toString().trim();
            displayStr = units ? (val + ' ' + units) : val;
          }
        }
      }

      if (!displayStr) {
        var msg = (tag.Message || tag.message || '').toString().trim();
        var statusStr = (status || '').toString().trim();
        if (msg && msg.toLowerCase() !== 'ok') displayStr = msg;
        else if (statusStr && statusStr.toLowerCase() !== 'ok') displayStr = statusStr;
        else if (msg || statusStr) displayStr = 'Normal';
      }

      var parsed = rawStr !== '' ? parseFloat(rawStr) : NaN;
      return { displayStr: displayStr, rawStr: rawStr, units: units, num: Number.isNaN(parsed) ? null : parsed };
    }

    function barPercentFromMetric(nameUpper, parts) {
      var disp = (parts.displayStr || '').toLowerCase();
      if (nameUpper.indexOf('SKIN_CATEGORY') !== -1) {
        if (disp.indexOf('oily') !== -1 && disp.indexOf('dry') === -1) return 88;
        if (disp.indexOf('combination') !== -1) return 72;
        if (disp.indexOf('dry') !== -1) return 38;
        if (disp.indexOf('normal') !== -1) return 55;
        return 50;
      }
      if (nameUpper.indexOf('SKINAGE') !== -1 || nameUpper === 'SKIN_AGE' || nameUpper.indexOf('BIOLOGICAL') !== -1) {
        var y = parts.num;
        if (y == null || Number.isNaN(y)) {
          var m = String(parts.rawStr || '').match(/(\d+)/);
          y = m ? parseFloat(m[1]) : null;
        if (y == null) return 0;
        }
        y = Math.max(18, Math.min(75, y));
        return Math.round(((y - 18) / (75 - 18)) * 100);
      }
      if (parts.num == null || Number.isNaN(parts.num)) return 0;
      var n = parts.num;
      // Normalize to 0-5 scale
      var valOutOf5 = n;
      if (n > 10) valOutOf5 = (n / 100) * 5;
      else if (n > 5) valOutOf5 = n / 2;
      
      return Math.min(100, Math.round((valOutOf5 / 5) * 100));
    }

    function findTagByPatterns(tags, patterns) {
      for (var i = 0; i < tags.length; i++) {
        var n = normTagName(tags[i]);
        if (!n || isImageishTagName(n)) continue;
        for (var p = 0; p < patterns.length; p++) {
          if (n.indexOf(patterns[p]) !== -1) return tags[i];
        }
      }
      return null;
    }

    var tags = data.Tags || data.tags || [];
    var hasScanData = Array.isArray(tags) && tags.length > 0;

    var scorePercent = null;
    // Calculation will happen after metricRows are populated below

    
    if (scorePercent == null || Number.isNaN(scorePercent)) {
        scorePercent = 0;
    }
    scorePercent = Math.max(0, Math.min(100, scorePercent));

    var skinAgeYearsLine = '';
    var ccSkinAgeLine = '';
    tags.forEach(function (tag) {
      var name = normTagName(tag);
      if (!name || name.indexOf('SKIN_CATEGORY') !== -1 || isImageishTagName(name)) return;
      var parts = getTagDisplayParts(tag);
      if (!parts.displayStr && !parts.rawStr) return;
      var u = (parts.units || '').toLowerCase();
      var n = parts.num;
      var raw = (parts.displayStr || parts.rawStr || '');
      
      if (name.indexOf('SKINAGE') !== -1 || name === 'SKIN_AGE' || (name.indexOf('AGE') !== -1 && (u.indexOf('year') !== -1 || (n != null && !Number.isNaN(n) && n > 12)))) {
        // If age is a long error message, don't show it as the primary age value
        if (raw.length > 20 || raw.toLowerCase().indexOf('unable') !== -1 || raw.toLowerCase().indexOf('resolution') !== -1) {
            if (!skinAgeYearsLine) skinAgeYearsLine = ''; 
        } else {
            skinAgeYearsLine = raw;
        }
      } else if (name.indexOf('CC') !== -1 && name.indexOf('AGE') !== -1) {
        if (raw.length < 20) ccSkinAgeLine = raw;
      }
    });

    var tSkinType = findTagByPatterns(tags, ['SKIN_CATEGORY', 'SKIN_TYPE', 'SKINTYPE']);
    var skinTypeLine = '';
    if (tSkinType) {
      var ps = getTagDisplayParts(tSkinType);
      skinTypeLine = (ps.rawStr || ps.displayStr || '').replace(/\s{2,}/g, ' ').trim();
    }
    if (!skinTypeLine && categorizedProfile['SKIN TYPE'] && categorizedProfile['SKIN TYPE'].length) {
      skinTypeLine = categorizedProfile['SKIN TYPE'].join(', ');
    }
    var sensitivityLine = (categorizedProfile['SENSITIVITY'] && categorizedProfile['SENSITIVITY'].length) ? categorizedProfile['SENSITIVITY'].join(', ') : '—';
    var tGender = findTagByPatterns(tags, ['GENDER']);
    var genderLine = '';
    if (tGender) {
      var gps = getTagDisplayParts(tGender);
      var graw = (gps.rawStr || gps.displayStr || '').toLowerCase();
      if (graw.indexOf('female') !== -1) genderLine = 'Female';
      else if (graw.indexOf('male') !== -1) genderLine = 'Male';
      else genderLine = (gps.rawStr || gps.displayStr || '');
    }
    
    // Smart extraction: check if gender is leaked in ANY tag message (API detection)
    if (!genderLine || genderLine.length > 15) {
        for (var i = 0; i < tags.length; i++) {
            var m = (tags[i].Message || tags[i].message || '').toLowerCase();
            var tn = (tags[i].TagName || tags[i].tagName || '').toLowerCase();
            if (m.indexOf('female') !== -1 || tn.indexOf('female') !== -1) { genderLine = 'Female'; break; }
            if (m.indexOf('male') !== -1 || tn.indexOf('male') !== -1) { genderLine = 'Male'; break; }
        }
    }

    // Questionnaire fallback (ONLY if API is silent)
    if (!genderLine && categorizedProfile['GENDER'] && categorizedProfile['GENDER'].length) {
      genderLine = categorizedProfile['GENDER'].join(', ');
    }
    if (!genderLine || genderLine.length > 15) genderLine = '—';

    if (isPlaceholderNoImage) {
      skinTypeLine = '';
      sensitivityLine = '—';
      genderLine = '—';
      skinAgeYearsLine = '';
      ccSkinAgeLine = '';
      scorePercent = 0;
    }

    function getScoreColor(s) {
      var hue;
      // Reverse scale: s=0 -> hue 130 (green), s=100 -> hue 0 (red)
      if (s < 40) hue = 130 - (s / 40) * 75;
      else if (s < 60) hue = 55 - ((s - 40) / 20) * 35;
      else hue = Math.max(0, 20 - ((s - 60) / 40) * 20);
      return {
        solid: 'hsl(' + hue + ',78%,50%)',
        glow: 'hsla(' + hue + ',85%,55%,0.45)',
        label: s < 40 ? 'Excellent' : (s < 60 ? 'Fair' : 'Needs Attention')
      };
    }
    // sc calculation moved after overall score calculation

    var ringPx = 220;
    if (typeof window !== 'undefined' && window.matchMedia) {
      try {
        if (window.matchMedia('(min-width: 769px)').matches) ringPx = 268;
      } catch (eRing) { /* ignore */ }
    }
    // Pointer math moved after overall score calculation


    function tagMatchesMetricRow(n, spec) {
      if (!n || (spec.skipIf && spec.skipIf(n))) return false;
      if (isImageishTagName(n)) return false;
      if (!spec.patterns || !spec.patterns.length) return false;
      for (var j = 0; j < spec.patterns.length; j++) {
        if (n.indexOf(spec.patterns[j]) !== -1) return true;
      }
      return false;
    }

    var metricOrder = [
      { label: 'Acne', patterns: ['ACNE'], fastImageKeys: ['ACNE_IMAGE_FAST', 'ACNE_IMAGE'] },
      { label: 'Pores', patterns: ['PORES'], fastImageKeys: ['PORES_IMAGE_FAST', 'PORES_IMAGE'] },
      { label: 'Spots', patterns: ['SPOTS', 'HYPERPIGMENT', 'PIH'], fastImageKeys: ['SPOTS_IMAGE_FAST', 'SPOTS_IMAGE'] },
      { label: 'Redness', patterns: ['REDNESS', 'ERYTHEMA'], fastImageKeys: ['REDNESS_IMAGE_FAST', 'REDNESS_IMAGE'] },
      { label: 'Shininess', patterns: ['SHININESS', 'GLOSS', 'OILINESS'], fastImageKeys: ['SHININESS_IMAGE_FAST', 'SHININESS_IMAGE'] },
      { label: 'Dehydration', patterns: ['DEHYDRATION', 'MOISTURE', 'HYDRATION'], fastImageKeys: ['DEHYDRATION_CONTOURS_COLORIZED_IMAGE_FAST', 'DEHYDRATION_IMAGE_FAST'] },
      { label: 'Dark Circles', patterns: ['DARK_CIRCLE', 'DARKCIRCLE', 'PERIORBITAL'], fastImageKeys: ['DARK_CIRCLES_IMAGE_FAST', 'DARK_CIRCLES_IMAGE'] },
      { label: 'Wrinkles', patterns: ['WRINKLES', 'WRINKLE'], skipIf: function (n) { return n.indexOf('FOREHEAD') !== -1; }, fastImageKeys: ['WRINKLES_IMAGE_FAST', 'WRINKLES_IMAGE'] },
      { label: 'Firmness', patterns: ['FIRMNESS', 'FIRMNES'], fastImageKeys: [] },
      { label: 'Env. Damage', patterns: ['ENV_DAMAGE', 'ENVIRONMENTAL', 'SUN_DAMAGE', 'PHOTO_DAMAGE', 'UV_DAMAGE', 'PHOTOAGING'], fastImageKeys: [] }
    ];

    var used = {};
    var metricRows = [];
    var totalPoints = 0;
    var maxPossiblePoints = 50; // 10 concerns * 5 points each

    metricOrder.forEach(function (spec) {
      var chosen = null;
      if (hasScanData) {
          for (var i = 0; i < tags.length; i++) {
            var n = normTagName(tags[i]);
            if (!n || used[n]) continue;
            if (tagMatchesMetricRow(n, spec)) {
              chosen = tags[i];
              break;
            }
          }
      }

      var pr = chosen ? getTagDisplayParts(chosen) : null;
      var pct = (chosen && pr) ? barPercentFromMetric(normTagName(chosen), pr) : 0;
      
      // Calculate normalized value out of 5 for display
      var valOutOf5 = 0;
      var hasNum = false;
      if (pr && pr.num != null && !Number.isNaN(pr.num)) {
          var n = pr.num;
          valOutOf5 = n;
          if (n > 10) valOutOf5 = (n / 100) * 5;
          else if (n > 5) valOutOf5 = n / 2;
          hasNum = true;
      } else if (pct > 0) {
          valOutOf5 = (pct / 100 * 5);
          hasNum = true;
      }
      
      // Cap at 5 and add to total points for overall score
      valOutOf5 = Math.min(5, Math.max(0, valOutOf5));
      totalPoints += valOutOf5;

      if (!chosen) {
          metricRows.push({
            label: spec.label,
            value: 0,
            rawValue: isPlaceholderNoImage ? '—' : '0',
            showSuffix: !isPlaceholderNoImage,
            thumbSrc: null
          });
          return;
      }

      used[normTagName(chosen)] = true;
      var displayVal = pr.displayStr || (hasNum ? (valOutOf5 % 1 === 0 ? valOutOf5.toString() : valOutOf5.toFixed(1)) : 'Normal');
      var thumbSrc = firstDataUrlFlatOrTags(data, spec.fastImageKeys || [], tags);
      metricRows.push({ 
          label: spec.label, 
          value: pct, 
          rawValue: displayVal, 
          showSuffix: hasNum,
          thumbSrc: thumbSrc 
      });
    });

    // Calculate overall score: (Sum of scores / 50) * 100
    if (hasScanData && !isPlaceholderNoImage) {
        scorePercent = Math.round((totalPoints / maxPossiblePoints) * 100);
    } else {
        scorePercent = 0;
    }

    // --- High-Precision SVG Gauge Architecture (Senior Engineer Refinement) ---
    // We use a 100x100 SVG space. 0 deg = 3 o'clock.
    var svgRadius = 42;
    var svgCenter = 50;
    var arcSweepDeg = 260; 
    var arcStartDeg = 140; // Bottom-Left position
    
    // Formula for dot position based on 0-100 score
    var progressFactor = scorePercent / 100;
    var currentAngleDeg = arcStartDeg + (progressFactor * arcSweepDeg);
    var currentAngleRad = currentAngleDeg * (Math.PI / 180);
    
    // Exact X/Y coordinates (Mathematical Centerline)
    var dotX = svgCenter + svgRadius * Math.cos(currentAngleRad);
    var dotY = svgCenter + svgRadius * Math.sin(currentAngleRad);
    
    // Semicircle Dash Math (No rotation for perfect gradient mapping)
    var circumference = 2 * Math.PI * svgRadius;
    var dashArray = (arcSweepDeg / 360) * circumference;
    var totalGap = circumference - dashArray;
    
    // The dash starts at 0 deg (3 o'clock). We need it to start at 140 deg.
    // Distance from 0 to 140 is 140 deg.
    var dashOffset = -((arcStartDeg / 360) * circumference);
    // --- End Engineering Logic ---




    var sc = isPlaceholderNoImage
      ? { solid: '#94a3b8', glow: 'transparent', label: '—' }
      : getScoreColor(scorePercent);

    var heroKeyOrder = [
      'SPOTS_IMAGE_FAST', 'PORES_IMAGE_FAST', 'ACNE_IMAGE_FAST', 'REDNESS_IMAGE_FAST',
      'SHININESS_IMAGE_FAST', 'WRINKLES_IMAGE_FAST', 'DARK_CIRCLES_IMAGE_FAST',
            'DEHYDRATION_CONTOURS_COLORIZED_IMAGE_FAST'
    ];
    var heroDataUrl = firstDataUrlFlatOrTags(data, heroKeyOrder, tags);

    var wrap = document.createElement('div');
    wrap.className = 'face-scan-analysis-wrap fsr-wrap' + (isPlaceholderNoImage ? ' fsr-wrap--placeholder' : '');
    var concernsLine = (categorizedProfile['SKIN CONCERNS'] && categorizedProfile['SKIN CONCERNS'].length) ? categorizedProfile['SKIN CONCERNS'].join(', ') : '—';
    if (isPlaceholderNoImage) {
      concernsLine = '—';
    }

    var faceSilInnerHtml;
    if (isPlaceholderNoImage) {
      /* Same look as Add all to bag — never use class "add-all-bag-btn" (cart sync rewires those nodes). */
      faceSilInnerHtml =
        '<button type="button" class="fsr-scan-cta-btn" aria-label="Take face scan">' +
        '<span class="fsr-scan-cta-label">Take face scan</span></button>';
    } else {
      faceSilInnerHtml = 'Face scan preview';
    }
    var scoreNumHtml = isPlaceholderNoImage ? '—' : String(scorePercent);

    var profileRowsHtml =
      '<div class="fsr-prow"><span class="fsr-plbl">Skin Type</span><span class="fsr-pval">' + (skinTypeLine || '—') + '</span></div>' +
      '<div class="fsr-prow"><span class="fsr-plbl">Sensitivity</span><span class="fsr-pval">' + sensitivityLine + '</span></div>' +
      '<div class="fsr-prow"><span class="fsr-plbl">Skin Concerns</span><span class="fsr-pval">' + concernsLine + '</span></div>';

    var qAge = (categorizedProfile['AGE'] && categorizedProfile['AGE'].length) ? categorizedProfile['AGE'].join(', ') : '';
    var finalAgeDisplay = skinAgeYearsLine || ccSkinAgeLine || qAge || '—';

    var floatingInfoHtml = 
      '<div class="fsr-floating-info">' +
        '<div class="fsr-fitem"><span class="fsr-flbl">Age</span><span class="fsr-fval">' + finalAgeDisplay + '</span></div>' +
        '<div class="fsr-fitem"><span class="fsr-flbl">Gender</span><span class="fsr-fval">' + genderLine + '</span></div>' +
      '</div>';

    var metricsHtml = metricRows.map(function (m, i) {
      // Use the provided thumbnail or fallback to the main hero image for consistency
      // Determine if we should show a thumbnail for this concern
      var isNoImageConcern = (m.label.toLowerCase().includes('firmness') || m.label.toLowerCase().includes('env. damage') || m.label.toLowerCase().includes('environmental'));
      var finalThumbSrc = isNoImageConcern ? null : (m.thumbSrc || heroDataUrl);
      
      var thumbCol = '';
      var rowCls = 'fsr-mcell';

      if (finalThumbSrc) {
        thumbCol = '<img class="fsr-mthumb" src="' + escapeHtmlAttr(finalThumbSrc) + '" alt="' + m.label + '" />';
        rowCls += ' fsr-mcell-with-thumb';
      }

      var pct = m.value; // 0–100
      
      // Calculate background-size to "reveal" the gradient. 
      // Handled via CSS !important to prevent squeezing.
      var pct = m.value; // 0–100

      // Determine a single solid color based on the score severity
      var solidColor = '#22c55e'; // Green (Low)
      if (pct > 75) solidColor = '#ef4444';      // Red (High)
      else if (pct > 40) solidColor = '#f59e0b'; // Orange (Moderate)

      return (
        '<div class="' + rowCls + '">' +
          thumbCol +
          '<div class="fsr-mcell-body">' +
            '<div class="fsr-mhdr">' +
              '<span class="fsr-mlbl">' + m.label + '</span>' +
              (
                isPlaceholderNoImage
                  ? '<span class="fsr-mval fsr-mval-dash">—</span>'
                  : '<span class="fsr-mval">' + m.rawValue + (m.showSuffix ? '<span>/5</span>' : '') + '</span>'
              ) +
            '</div>' +
            '<div class="fsr-btrack-wrap">' +
              '<div class="fsr-btrack"></div>' +
              '<div class="fsr-bfill" style="width:' + pct + '%; background:' + solidColor + ' !important; animation:fsr-barFill 0.9s cubic-bezier(0.4,0,0.2,1) ' + (800 + i * 60) + 'ms both;"></div>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    wrap.innerHTML =
      '<div class="fsr-report-nav">' +
        '<div class="fsr-nav-left">' +
          '<div class="fsr-eyebrow">AI Skin Decoder</div>' +
          '<h3 class="fsr-h1">Face Scan Report</h3>' +
        '</div>' +
        '<div class="fsr-nav-right">' +
          '<button class="fsr-nav-btn secondary">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>' +
            '<span>Face Scan Report</span>' +
          '</button>' +
          '<div class="fsr-retake-dropdown-wrap">' +
            '<button class="fsr-nav-btn active" onclick="var d=this.nextElementSibling; var isV=d.style.display===\'flex\'; document.querySelectorAll(\'.fsr-retake-dropdown\').forEach(x=>x.style.display=\'none\'); d.style.display=(isV?\'none\':\'flex\'); event.stopPropagation();">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M23 4v6h-6"></path><path d="M1 20v-6h6"></path><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>' +
              '<span>Retake Test</span>' +
            '</button>' +
            '<div class="fsr-retake-dropdown">' +
              '<button onclick="if(window.ChatbotRetakeTest) window.ChatbotRetakeTest(); else window.location.reload();">Full Test (Face Scan + Questionnaire)</button>' +
              '<button onclick="if(window.ChatbotRetakeQuestionnaire) window.ChatbotRetakeQuestionnaire();">Questionnaire Only</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="fsr-inner">' +
        '<div class="fsr-hero">' +
            '<div class="fsr-ring-side">' +
            '<div class="fsr-ring-wrap">' +
              '<svg class="fsr-ring-svg-new" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet">' +
                '<defs>' +
                  '<linearGradient id="gaugeGradient" x1="0%" y1="0%" x2="100%" y2="0%">' +
                    '<stop offset="0%" stop-color="#22c55e" />' +
                    '<stop offset="33%" stop-color="#eab308" />' +
                    '<stop offset="66%" stop-color="#f97316" />' +
                    '<stop offset="100%" stop-color="#ef4444" />' +
                  '</linearGradient>' +
                '</defs>' +
                '<!-- Static Gradient Track (No Rotation for Perfect Mapping) -->' +
                '<circle class="fsr-svg-bg" cx="50" cy="50" r="' + svgRadius + '" ' +
                  'stroke="url(#gaugeGradient)" stroke-width="3.5" fill="transparent" ' +
                  'stroke-dasharray="' + dashArray + ' ' + totalGap + '" ' +
                  'stroke-dashoffset="' + dashOffset + '" ' +
                  'stroke-linecap="round" />' +
              '</svg>' +
              '<!-- Indicator Dot (Point-in-Dot Style) -->' +
              '<div class="fsr-pointer-dot fsr-pointer-dot--point" style="left:' + dotX.toFixed(2) + '%; top:' + dotY.toFixed(2) + '%; --fsr-point-color:' + sc.solid + ';">' +
                '<div class="fsr-dot-inner-point"></div>' +
              '</div>' +
              '<div class="fsr-gauge-labels"><span class="fsr-label-good">Good</span><span class="fsr-label-poor">Poor</span></div>' +
              '<div class="fsr-face-circle"><div class="fsr-face-sil' + (isPlaceholderNoImage ? ' fsr-face-sil--prompt fsr-face-sil--hub' : '') + '">' + faceSilInnerHtml + '</div></div>' +
            '</div>' +
          '</div>' +
          '<div class="fsr-info fsr-fade-up">' +
            floatingInfoHtml +
            '<div class="fsr-status-row"><span class="fsr-dot" style="background:' + sc.solid + ';box-shadow:0 0 8px ' + sc.glow + ';"></span><span class="fsr-status-lbl" style="color:' + sc.solid + ';">' + sc.label + '</span></div>' +
            '<div class="fsr-score-row"><span class="fsr-score-num">' + scoreNumHtml + '</span>' + (isPlaceholderNoImage ? '' : '<span class="fsr-score-den">/ 100</span>') + '</div>' +
            '<div class="fsr-score-sub">Overall skin score</div>' +
            '<div class="fsr-plist">' + profileRowsHtml + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="fsr-breakdown">' +
          '<div class="fsr-bk-hdr">' +
            '<h4 class="fsr-bk-title">Concern Breakdown</h4>' +
            '<div class="fsr-bk-meta">' +
              '<span class="fsr-bk-count">' + metricRows.length + ' markers</span>' +
              '<button class="fsr-info-trigger" title="Feature Info"><i>i</i></button>' +
            '</div>' +
          '</div>' +
          '<div class="fsr-mgrid">' + metricsHtml + '</div>' +
        '</div>' +
      '</div>';

    var faceSil = wrap.querySelector('.fsr-face-sil');

    // Wire up retake dropdown — proper event listeners (scripts in innerHTML don't execute)
    var retakeDropdown = wrap.querySelector('.fsr-retake-dropdown');
    var retakeToggleBtn = wrap.querySelector('.fsr-retake-dropdown-wrap .fsr-nav-btn.active');
    if (retakeDropdown && retakeToggleBtn) {
      retakeToggleBtn.removeAttribute('onclick');
      retakeToggleBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        var isVisible = retakeDropdown.style.display === 'flex';
        retakeDropdown.style.display = isVisible ? 'none' : 'flex';
      });
      document.addEventListener('click', function(e) {
        if (!retakeToggleBtn.contains(e.target) && !retakeDropdown.contains(e.target)) {
          retakeDropdown.style.display = 'none';
        }
      });
    }

    if (faceSil && heroDataUrl) {
      faceSil.classList.add('fsr-has-preview');
      faceSil.innerHTML = '<img class="fsr-face-preview-img" src="' + escapeHtmlAttr(heroDataUrl) + '" alt="" style="cursor:zoom-in" />';
      faceSil.onclick = function() { openFSRImageModal(heroDataUrl); };
    }

    var hubBtn = wrap.querySelector('.fsr-scan-cta-btn');
    if (hubBtn && typeof opts.onPlaceholderAiTest === 'function') {
      hubBtn.addEventListener('click', function (ev) {
        ev.stopPropagation();
        opts.onPlaceholderAiTest(ev);
      });
    }

    // Attach click listeners to thumbnails
    var thumbs = wrap.querySelectorAll('.fsr-mthumb');
    thumbs.forEach(function(img) {
      img.style.cursor = 'zoom-in';
      img.onclick = function() {
        openFSRImageModal(img.src);
      };
    });

    // Attach click listener to info button
    var infoBtn = wrap.querySelector('.fsr-info-trigger');
    if (infoBtn) {
        infoBtn.onclick = function() {
            openFSRInfoModal();
        };
    }

    return wrap;
  }

  /**
   * Modal to show skin concern info & classifications
   */
  function openFSRInfoModal() {
    var existing = document.querySelector('.fsr-info-modal');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

    var modal = document.createElement('div');
    modal.className = 'fsr-info-modal';
    
    // Feature data matching common concerns
    var featureData = [
      { f: 'Acne', d: 'The degree of inflammation and frequency of acne lesions on the skin surface.' },
      { f: 'Redness', d: 'Degree of red and/or irritated skin, often caused by inflammation or sensitivity.' },
      { f: 'Pores', d: 'Visible skin openings, often appearing larger due to congestion or loss of elasticity.' },
      { f: 'Spots', d: 'Pigmented areas darker than surrounding skin (sun spots, age spots, post-acne marks).' },
      { f: 'Wrinkles', d: 'Fine lines and creases caused by aging, sun exposure, and repetitive expressions.' },
      { f: 'Dark Circles', d: 'Periorbital hyperpigmentation or shadow-like appearance under the eyes.' }
    ];

    // Complete feature data with actual Shopify image URLs
    var featureData = [
      { f: 'Redness', d: 'The degree of red and/or irritated skin.', img: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/imgi_7_Redness.webp?v=1777453327' },
      { f: 'Uneven Skin tone', d: 'The degree of skin discoloration roughened texture.', img: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/imgi_8_UnevenSkintone.png?v=1777453327' },
      { f: 'Wrinkles', d: 'Wrinkles caused by aging, sun exposure and poor lifestyle e.g. smoking. Assessed in terms of size and quantity.', img: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/imgi_9_Wrinkles.png?v=1777453327' },
      { f: 'Pigmentation', d: 'Pigmented spots that are darker than the surrounding skin. Assessed in terms of size and quantity.', img: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/imgi_10_Pigmentation.png?v=1777453327' },
      { f: 'Pores', d: 'The small openings in the skin in which oil and sweat reach the surface from their respective glands. Assessed in terms visibility and size.', img: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/imgi_11_Pores.png?v=1777453327' },
      { f: 'Acne', d: 'Acne occurs when the pores of skin become blocked with oil, dead skin, or bacteria. These can form acne lesions which can become inflamed in more severe instances. Assessed in terms visibility and size.', img: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/imgi_12_Acne.png?v=1777453327' },
      { f: 'Texture', d: "The texture of the skin's surface, which can become rougher and more irregular with age and poor lifestyle.", img: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/imgi_13_Texture.png?v=1777453327' },
      { f: 'Dark Circles', d: "The degree to which the under eye area's pigmentation differs from the surrounding area. Assess in terms of size and relative darkness.", img: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/imgi_14_DarkCircles.png?v=1777453327' },
      { f: 'Shininess', d: 'How shiny the skin appears - typically caused by excess sebum or poor skin texture.', img: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/imgi_15_Shininess.png?v=1777453327' },
      { f: 'Dehydration', d: 'How dull the skin appears. The overall tone and complexion may appear uneven, with fine lines more noticeable.', img: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/imgi_16_Dehydration_d4480126-f908-4bcd-a3aa-be0391f8e0f8.png?v=1777453326' },
      { f: 'Firmness & Elasticity', d: "The skin's ability to stretch and snap back to its original shape.", c: 0 },
      { f: 'Skin type', d: 'The subject\'s skin tone assessed from light to dark. These are classified into six different skin types which ranges from very fair (skin type I) to very dark (skin type VI).', c: 6, type: 'circles' },
      { f: 'Gender', d: 'Whether the subject in the photo is male/female.', t: 'Male, Female' },
      { f: 'Age', d: 'The estimated age of the subject of the photo.', t: '0 to 71+' },
      { f: 'Haircolor', d: 'The color or shade of the subject\'s hair.', img: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/imgi_18_Haircolor.webp?v=1777453327' },
      { f: 'Hair type', d: 'The subject\'s hair type.', img: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/imgi_19_Hairtype.png?v=1777453328' },
      { f: 'Environmental damage', d: 'A simulated image of how the subject may appear under a UV light and the sun damage it may show.', c: 1, type: 'uv' }
    ];

    var tableRows = featureData.map(function(item, idx) {
        var classificationHtml = '';
        
        if (item.img) {
            // Use the provided strip image
            classificationHtml = '<div class="fsr-info-img-strip"><img src="' + item.img + '" alt="' + item.f + ' classification" /></div>';
        } else if (item.t) {
            // Simple text classification
            classificationHtml = '<div class="fsr-info-text-class">' + item.t + '</div>';
        } else if (item.type === 'circles') {
            // Skin type circles
            classificationHtml = '<div class="fsr-info-circles-class">';
            for (var i = 1; i <= item.c; i++) {
                classificationHtml += '<div class="fsr-info-type-circle s' + i + '">' + i + '</div>';
            }
            classificationHtml += '</div>';
        } else if (item.type === 'uv') {
            // UV image
            classificationHtml = '<div class="fsr-info-uv-box"></div>';
        } else if (item.c > 0) {
            // Generic image grid if no specific img provided
            classificationHtml = '<div class="fsr-info-classes-imgs">';
            for (var i = 1; i <= item.c; i++) {
                var imgUrl = 'https://loremflickr.com/100/100/skin,face?lock=' + (idx * 10 + i);
                classificationHtml += 
                  '<div class="fsr-class-img-box">' +
                    '<div class="fsr-class-img-placeholder p' + i + '" style="background-image:url(' + imgUrl + ')"></div>' +
                    '<span>' + i + '</span>' +
                  '</div>';
            }
            classificationHtml += '</div>';
        }

        return (
          '<tr>' +
            '<td class="fsr-td-feat"><strong>' + item.f + '</strong></td>' +
            '<td class="fsr-td-desc">' + item.d + '</td>' +
            '<td class="fsr-td-class">' + classificationHtml + '</td>' +
          '</tr>'
        );
    }).join('');

    modal.innerHTML = 
      '<div class="fsr-modal-overlay"></div>' +
      '<div class="fsr-modal-content fsr-info-content">' +
        '<div class="fsr-info-header">' +
            '<h3>DeepTag Features Information</h3>' +
            '<button class="fsr-modal-close-round" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="fsr-info-body">' +
          '<div class="fsr-info-severity">' +
            '<h4>Severity Classification Description</h4>' +
            '<div class="fsr-sev-grid">' +
              '<div class="fsr-sev-card">' +
                '<div class="fsr-sev-card-inner">' +
                  '<p class="fsr-sev-top">Low</p>' +
                  '<div class="fsr-sev-gauge g1"><span>1</span></div>' +
                '</div>' +
                '<span class="fsr-sev-bottom">Healthy Skin</span>' +
              '</div>' +
              '<div class="fsr-sev-card">' +
                '<div class="fsr-sev-card-inner">' +
                  '<p class="fsr-sev-top">Low-Moderate</p>' +
                  '<div class="fsr-sev-gauge g2"><span>2</span></div>' +
                '</div>' +
                '<span class="fsr-sev-bottom">Low to moderate skin condition severity</span>' +
              '</div>' +
              '<div class="fsr-sev-card">' +
                '<div class="fsr-sev-card-inner">' +
                  '<p class="fsr-sev-top">Moderate</p>' +
                  '<div class="fsr-sev-gauge g3"><span>3</span></div>' +
                '</div>' +
                '<span class="fsr-sev-bottom">Moderate skin condition severity</span>' +
              '</div>' +
              '<div class="fsr-sev-card">' +
                '<div class="fsr-sev-card-inner">' +
                  '<p class="fsr-sev-top">Moderate-High</p>' +
                  '<div class="fsr-sev-gauge g4"><span>4</span></div>' +
                '</div>' +
                '<span class="fsr-sev-bottom">Moderate to high skin condition severity</span>' +
              '</div>' +
              '<div class="fsr-sev-card">' +
                '<div class="fsr-sev-card-inner">' +
                  '<p class="fsr-sev-top">High</p>' +
                  '<div class="fsr-sev-gauge g5"><span>5</span></div>' +
                '</div>' +
                '<span class="fsr-sev-bottom">High level of skin condition severity</span>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="fsr-info-table-wrap">' +
            '<h4>Feature Description & Classification</h4>' +
            '<table class="fsr-info-table">' +
              '<thead><tr><th>Feature</th><th>Description</th><th>Classification</th></tr></thead>' +
              '<tbody>' + tableRows + '</tbody>' +
            '</table>' +
          '</div>' +
        '</div>' +
      '</div>';
      
    document.body.appendChild(modal);
    requestAnimationFrame(function() { modal.classList.add('is-active'); });
    
    var closeFn = function() {
      modal.classList.remove('is-active');
      setTimeout(function() { if (modal.parentNode) modal.parentNode.removeChild(modal); }, 300);
    };
    modal.querySelector('.fsr-modal-overlay').onclick = closeFn;
    modal.querySelector('.fsr-modal-close-round').onclick = closeFn;
  }

  /**
   * Simple modal to show analysis images in large view
   */
  function openFSRImageModal(src) {
    if (!src) return;
    
    // Remove any existing modal first
    var existing = document.querySelector('.fsr-image-modal');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    
    var modal = document.createElement('div');
    modal.className = 'fsr-image-modal';
    modal.innerHTML = 
      '<div class="fsr-modal-overlay"></div>' +
      '<div class="fsr-modal-content">' +
        '<div class="fsr-modal-img-wrap">' +
          '<img src="' + src + '" alt="Skin Analysis Preview" />' +
        '</div>' +
        '<button class="fsr-modal-close" aria-label="Close">&times;</button>' +
      '</div>';
      
    document.body.appendChild(modal);
    
    // Transition in
    requestAnimationFrame(function() {
      modal.classList.add('is-active');
    });
    
    var closeFn = function() {
      modal.classList.remove('is-active');
      setTimeout(function() {
        if (modal.parentNode) modal.parentNode.removeChild(modal);
      }, 300);
    };
    
    modal.querySelector('.fsr-modal-overlay').onclick = closeFn;
    modal.querySelector('.fsr-modal-close').onclick = closeFn;
    
    // Escape key support
    var escHandler = function(e) {
      if (e.key === 'Escape') {
        closeFn();
        document.removeEventListener('keydown', escHandler);
      }
    };
    document.addEventListener('keydown', escHandler);
  }

  window.ChatbotProductsFSR = {
    renderFaceScanAnalysis: renderFaceScanAnalysis
  };
})();

